var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFastfood(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#c73b40;}.cls-2{fill:#d26266;}.cls-3{fill:#ffff97;}.cls-4{fill:#ffffac;}.cls-5{fill:#603813;}.cls-6{fill:#806042;}.cls-7{fill:#f4a13c;}.cls-8{fill:#f6b463;}.cls-9{fill:#fccb7e;}.cls-10{fill:#fdd598;}.cls-11{fill:#aa7b50;}.cls-12{fill:#bb9573;}.cls-13{fill:#8cc63f;}.cls-14{fill:#a3d165;}.cls-15{fill:red;}.cls-16{fill:#f77;}.cls-17{fill:#e6e6e6;}"))), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 25",
    id: "Layer_25"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M53.733,20.32A1,1,0,0,0,53,20H27a1,1,0,0,0-1,1.076l1,12.973a1,1,0,0,0,1.593.724,3.832,3.832,0,0,1,4.707.1,1,1,0,0,0,1.25,0,3.809,3.809,0,0,1,4.822,0,1,1,0,0,0,1.25,0,3.809,3.809,0,0,1,4.822,0,1,1,0,0,0,1.25,0,3.831,3.831,0,0,1,4.707-.1A1,1,0,0,0,53,34.049l1-12.973A1,1,0,0,0,53.733,20.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M53.733,20.32A1,1,0,0,0,53,20H51a1,1,0,0,1,1,1.076L51,34.049a.98.98,0,0,1-.125.394,3.942,3.942,0,0,1,.532.33A1,1,0,0,0,53,34.049l1-12.973A1,1,0,0,0,53.733,20.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.218,64H38.1a1,1,0,0,1-1-.928L35.667,43.217h0l-.555-7.669a1,1,0,0,1,1.994-.149l2.109,27.525a1,1,0,0,1-1,1.076Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M52.6,33.168a5.837,5.837,0,0,0-6.524-.3,5.792,5.792,0,0,0-6.072,0,5.792,5.792,0,0,0-6.072,0,5.837,5.837,0,0,0-6.524.3,1,1,0,0,0-.4.875l2.218,29.033a1,1,0,0,0,1,.924H49.9a1,1,0,0,0,1-.928l1.992-27.524L53,34.043A1,1,0,0,0,52.6,33.168Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M50.6,33.168a5.837,5.837,0,0,0-6.524-.3,5.792,5.792,0,0,0-6.072,0,5.792,5.792,0,0,0-6.072,0,5.837,5.837,0,0,0-6.524.3,1,1,0,0,0-.4.875l2.218,29.033a1,1,0,0,0,1,.924H47.9a1,1,0,0,0,1-.928l1.992-27.524L51,34.043A1,1,0,0,0,50.6,33.168Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M52.6,33.168a5.848,5.848,0,0,0-4.46-1.055,5.849,5.849,0,0,1,2.46,1.055,1,1,0,0,1,.4.875l-.109,1.505L48.9,63.072a1,1,0,0,1-1,.928h2a1,1,0,0,0,1-.928l1.992-27.524L53,34.043A1,1,0,0,0,52.6,33.168Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M35,53H13a3,3,0,0,0,0,6H35a3,3,0,0,0,0-6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M35,53H33a3,3,0,0,1,0,6h2a3,3,0,0,0,0-6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M36.5,57h-25a3.5,3.5,0,0,0,0,7h25a3.5,3.5,0,0,0,0-7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M36.5,57h-2a3.5,3.5,0,0,1,0,7h2a3.5,3.5,0,0,0,0-7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M35.5,50h-23a2.5,2.5,0,0,0,0,5H26.586l1.707,1.707a1,1,0,0,0,1.414,0L31.414,55H35.5a2.5,2.5,0,0,0,0-5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M35.5,50h-2a2.5,2.5,0,0,1,0,5h2a2.5,2.5,0,0,0,0-5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M34.887,45.772H13.113a3.114,3.114,0,0,0,0,6.228H34.887a3.114,3.114,0,0,0,0-6.228Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M34.887,45.772h-2a3.114,3.114,0,0,1,0,6.228h2a3.114,3.114,0,0,0,0-6.228Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M37.733,44.614A1.928,1.928,0,0,0,35.923,43H12.077a1.93,1.93,0,0,0-1.811,1.616A8.48,8.48,0,0,0,10,46.286,2.505,2.505,0,0,0,12.3,49a2.063,2.063,0,0,0,1.3-.473,2.1,2.1,0,0,0,2.6,0,2.1,2.1,0,0,0,2.6,0,2.1,2.1,0,0,0,2.6,0,2.1,2.1,0,0,0,2.6,0,2.1,2.1,0,0,0,2.6,0,2.1,2.1,0,0,0,2.6,0,2.1,2.1,0,0,0,2.6,0,2.1,2.1,0,0,0,2.6,0A2.063,2.063,0,0,0,35.7,49,2.505,2.505,0,0,0,38,46.286,8.47,8.47,0,0,0,37.733,44.614Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M37.733,44.614A1.928,1.928,0,0,0,35.923,43h-2a1.928,1.928,0,0,1,1.81,1.614A8.47,8.47,0,0,1,36,46.286a2.746,2.746,0,0,1-1.3,2.444,2.014,2.014,0,0,0,1,.27A2.505,2.505,0,0,0,38,46.286,8.47,8.47,0,0,0,37.733,44.614Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    height: 5,
    rx: 2,
    width: 28,
    x: 10,
    y: 40
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M36,40H34a2,2,0,0,1,2,2v1a2,2,0,0,1-2,2h2a2,2,0,0,0,2-2V42A2,2,0,0,0,36,40Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M37.715,34.885a34.164,34.164,0,0,0-27.431,0A3.651,3.651,0,0,0,8,38.225v.108A3.8,3.8,0,0,0,11.9,42H36.1A3.8,3.8,0,0,0,40,38.333v-.108A3.65,3.65,0,0,0,37.715,34.885Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M37.715,34.885A34.863,34.863,0,0,0,23,32.037a35.339,35.339,0,0,1,12.715,2.848A3.65,3.65,0,0,1,38,38.225v.108A3.8,3.8,0,0,1,34.1,42h2A3.8,3.8,0,0,0,40,38.333v-.108A3.65,3.65,0,0,0,37.715,34.885Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    height: 18,
    rx: 1,
    width: 6,
    x: 37
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    height: 6,
    rx: 1,
    width: 32,
    x: 24,
    y: 16
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M55,16H53a1,1,0,0,1,1,1v4a1,1,0,0,1-1,1h2a1,1,0,0,0,1-1V17A1,1,0,0,0,55,16Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFastfood);
export default __webpack_public_path__ + "static/media/fastfood.73f80ff3bf8f9ad5bd406e3be3b2326b.svg";
export { ForwardRef as ReactComponent };